$ = require 'jquery'
View = require 'view'
entOrgPrefsPermissionLevel = require 'views/templates/ent_org_prefs_permission_level'
l = require 'lib/localize'

module.exports = class OrganizationRestrictVisibilityView extends View
  viewTitleKey: 'select team visibility'

  initialize: ->
    @listenTo @model, 'change:organizationPrefs', @frameDebounce @render

  events:
    'click a': 'changeRestriction'

  render: ->
    enterprise = @model.toJSON()

    text =
      privateText: l(['ent orgPrefs', 'visibility', 'private'])

    @$el.html(entOrgPrefsPermissionLevel(enterprise, text))

    @

  changeRestriction: (e) ->
    $target = $(e.target)

    prefName = "permissionLevel"
    setting = $target.closest('a').attr('data-restriction')

    isEnforcingSetting = @model.get('organizationPrefs').permissionLevel?

    if setting == 'undefined'
      if isEnforcingSetting
        @model.deleteOrganizationPref(prefName)
    else
      @model.setOrganizationPref(prefName, setting)



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/organization-restrict-visibility-view.coffee